import React from 'react'
import createReactClass from 'create-react-class'
import DynamicForm from '../forms/search-form'
import FilteredMultiSelectDropdown from '../filtered-multi-select-dropdown'
import './search-form-panel.scss'
import ErrorBlock from '../../elements/error-block'

export default createReactClass({
  getInitialState () {
    return {
      countries: this.mapSelectedCountries(this.props.countryList),
      selectedCountries: [],
    }
  },

  deepClone (options = []) {
    return options.map((option) => {
      return {...option}
    })
  },

  mapSelectedCountries (countries = []) {
    // clone the list so that all updations wouldn't disturb the original list.
    let countryList = this.deepClone(countries)
    if (countryList.length > 0) {
      this.props.params.countries.map((country) => {
        for (let i = 0; i < countryList.length; i++) {
          if (countryList[i].value === country) {
            countryList[i].selected = true
            break
          }
        }
        return null
      })
    }
    return countryList
  },

  afterCountrySelection (selectedOptions = []) {
    this.props.clearSearchCriteria()
    this.setState({selectedCountries: selectedOptions})
    selectedOptions.length > 0 && this.props.getSearchCriteria(selectedOptions.join())
  },

  isCriteriaSetsAvailable () {
    let sets = this.props.criteriaSets
    return sets && Array.isArray(sets) && sets.length > 0
  },
  render () {
    return (
      <div className="search-form-panel">
        <div className="form-group row">
          <div className="col-lg-3 col-md-3">
            {this.props.countryLoader && <div className='country-loader'><i className="fa fa-spinner fa-spin"></i></div>}
            <FilteredMultiSelectDropdown
              onAfterSelection={this.afterCountrySelection}
              options={this.state.countries}
              textProp="name"
              valueProp="value"
              isLoading={this.props.paramsLoader}
              showButton={false}
              countryLoader={this.props.countryLoader}
            />
          </div>
          <div className="col-lg-9 col-md-9">
            {this.props.paramsLoader ? <div className='loader-ctr'><span className="loading"></span></div> : false }
            {this.props.paramsError
              ? <ErrorBlock {...this.props.paramsError}/>
              : <div>{this.isCriteriaSetsAvailable() ? <DynamicForm {...this.props} data={this.props.criteriaSets}/>
                : this.props.criteriaSets === 'null' ? 'No Criteria found' : ''}</div>
            }
          </div>
        </div>
      </div>
    )
  },
  componentDidMount () {
    if (this.state.countries.length === 0) {
      this.props.getAccessCountries()
      this.props.getUserDetails(this.props.getUserAccessActions)
    }
  },

  componentWillReceiveProps (nextProps) {
    if (this.state.countries.length === 0 && nextProps.countryList.length > 0) {
      this.setState({countries: this.mapSelectedCountries(nextProps.countryList)})
    }
  },
})



// WEBPACK FOOTER //
// ./src/components/search-page/search-form-panel.js